<template>
    <div class="page outreach">
        <h1>Outreach</h1>
        <div class="under-contstruction">
            <p><em>
                We're had lots of interest from folks who want to help us share the word about Unpaywall. We're working to create materials to help y'all out with that, and we'll put them on this page when we're done.
            </em></p>
        </div>

        <h2>Logos</h2>
        <div class="logo">

        </div>


    </div>
</template>

<script>
    export default {
        name: "Outreach",
        metaInfo: {
            title: "Outreach"
        }
    }
</script>

<style scoped>

</style>